/* eslint-disable no-void */

import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';

import vopayApi from '../../services/api.config';
import { useDataFetchIndicator } from '..';

type HookProps = { api: vp.Api };
type HookTuple = [
  { details: vp.HubSpotDealDetails },
  (dealID: string) => Promise<vp.HubSpotDealDetailsResponse>,
  (dealID: string) => void,
  () => void,
];
type ApiHook = (props: HookProps) => HookTuple;
//Temporary normalization function to handle inconsistent API response for PrimaryContact (object vs single contact) — can be removed once API is fixed
function normalizeDetails(details: vp.HubSpotDealDetails): vp.HubSpotDealDetails {
  const rawContact = details.PrimaryContact as unknown as Record<string, vp.HubSpotDealContactDetails>;
  const normalizedContact = Object.values(rawContact)[0] ?? details.PrimaryContact;
  return { ...details, PrimaryContact: normalizedContact };
}

const defaulValues: vp.HubSpotDealDetails = {
  CompanyProfile: { CompanyHubspotID: null, HubSpotDealID: null, Country: null, AccountLink: null },
  PrimaryContact: {
    firstname: null,
    lastname: null,
    email: null,
  },
  BusinessInformation: {
    CompanyName: null,
    Dba: null,
    CompanyWebsite: null,
    SocialMediaPage: null,
    CompanyPhone: null,
    PaymentMethod: null,
  },
  CompanyHubspotID: '',
  CompanyName: '',
  Industry: '',
  Country: '',
  AccountLink: '',
  CompanyWebsite: '',
  PlatformUsage: '',
  CompanyPhone: '',
  SocialMediaPage: '',
  DealCountry: '',
  DealCurrency: '',
};
const useFetchHubSpotDealDetails: ApiHook = ({ api }) => {
  const source = axios.CancelToken.source();
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [dealID, setDealID] = useState('');
  const [details, setDetails] = useState<vp.HubSpotDealDetails>(defaulValues);

  useEffect(() => {
    const loadData = async () => {
      setDataFetchingInfo(true, 'Loading Data', 'fullScreen');
      const { Details } = await api.fetchHubSpotDealData({ DealID: dealID }, source);
      setDataFetchingInfo(false);
      if (Details) setDetails(normalizeDetails(Details));
    };

    if (dealID) void loadData();

    return () => {
      source.cancel();
    };
  }, [dealID]);

  return [
    { details },
    async (_dealID: string) => {
      const response = await api.fetchHubSpotDealData({ DealID: _dealID }, source);
      if (response.Details) response.Details = normalizeDetails(response.Details);
      return response;
    },
    (_dealID: string) => setDealID(_dealID),
    () => {
      setDetails(defaulValues);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(useFetchHubSpotDealDetails);
